import { render } from "./Emojis.vue?vue&type=template&id=1f53f4f2&scoped=true"
import script from "./Emojis.vue?vue&type=script&lang=js"
export * from "./Emojis.vue?vue&type=script&lang=js"

import "./Emojis.vue?vue&type=style&index=0&id=1f53f4f2&scoped=true&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f53f4f2"]])

export default __exports__